/* btg-header.js — By The Gaze · header scroll state + full-screen menu toggle */
(function () {
  'use strict';
  var header = document.querySelector('[data-header]');
  if (!header) return;

  function onScroll() {
    if ((window.scrollY || window.pageYOffset) > 40) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  var toggle = header.querySelector('[data-menu-toggle]');
  var menu = header.querySelector('[data-menu]');
  if (!toggle || !menu) return;

  function setOpen(open) {
    header.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  toggle.addEventListener('click', function () {
    setOpen(!header.classList.contains('menu-open'));
  });

  // Close when a menu link is tapped (real links then navigate via the page-transition curtain)
  menu.addEventListener('click', function (e) {
    if (e.target.closest('a')) setOpen(false);
  });

  // Close when the blurred backdrop is clicked
  var backdrop = header.querySelector('[data-menu-close]');
  if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && header.classList.contains('menu-open')) setOpen(false);
  });
})();
